import React from "react";

export function FlightBookingMockupStepCardLayout({
  variant = "full",
  desc,
  title,
  bullets,
  children,
  className = "",
}) {
  if (variant === "body") {
    return <div className={["fw-step-body", className].filter(Boolean).join(" ")}>{children}</div>;
  }
  return (
    <div className="fw-ui-card fw-ui-card--compact">
      <div className="fw-ui-screen-desc">{desc}</div>
      <div className="fw-ui-screen-title">{title}</div>
      <ul className="fw-ui-list">
        {bullets.map((b, j) => (
          <li key={`${title}-${j}`}>• {b}</li>
        ))}
      </ul>
      {children}
    </div>
  );
}
